import React, { useEffect, useRef } from 'react'
//Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import $ from 'jquery'; 

function DataTable({ tableConfig, downloadOptions, usePagination }) {
    // tableData: An array of arrays
    // tableColumns: An array of arrays
    const tableRef = useRef()
    const { tableData, tableColumns, tableColumnIds, handleRowClick, hasHoverEffect } = tableConfig ? tableConfig : { tableData: [], tableColumns: [], tableColumnIds: [], hasHoverEffect: false }
    const { hasDownload, setSelectedDownloadItems, selectedDownloadItems } = downloadOptions ? downloadOptions : { hasDownload: false, setSelectedDownloadItems: () => { }, selectedDownloadItems: [] }
    

    useEffect(() => {
        if (tableColumns.length > 0) {
            const table = $(tableRef.current).DataTable({
                select: true,
                lengthChange: false,
                paging: usePagination,
                searching: true,
                columns: hasDownload ? [{ title: 'Download' }, ...tableColumns.map(col => { return { title: col } })] : tableColumns.map(col => { return { title: col } }),
                destroy: true
            });
            return () => table.destroy();
        }
    }, [tableColumns]);
    function handleDownloadSelect(event, item) {
        const itemIndex = selectedDownloadItems.indexOf(item)
        if (event.target.checked) {
            if (itemIndex < 0) {
                setSelectedDownloadItems([...selectedDownloadItems, item])
            }
        } else {
            const newSelection = itemIndex === 0 && selectedDownloadItems.length < 1 ? [] : selectedDownloadItems.toSpliced(itemIndex, 1)
            setSelectedDownloadItems(newSelection)
        }
    }

    function renderRow(row) {
        if (typeof row === 'object')
            return "";
        else if (typeof row === 'string')
            return row.replace("\u0000", "")
        else
            return row;
    }

    return (
        <table className='react-data-table' ref={tableRef}>
            <thead>
                <tr>
                    {
                        hasDownload ?
                            ['Download', ...tableColumns].map((column, index) => <th key={index}>{column}</th>)
                            : tableColumns.map((column, index) => <th key={index}>{column}</th>)
                    }
                </tr>
            </thead>
            <tbody>
                    {tableData.map((tableRow, index) => {
                        return (
                            <tr className={hasHoverEffect ? 'react-data-table-effect' : ''} key={index} onClick={() => handleRowClick(tableRow[tableConfig.rowId])}>  
                            {hasDownload ? <td onChange={e => handleDownloadSelect(e, tableRow)}><div className='download-input'><input type='checkbox' /></div></td> : ''}
                            {tableColumnIds.map((tableCol, index) => {
                                if (tableCol === 'nodes') return <td key={1000 + index}>--NODES_ARRAY--</td>
                                return (
                                    <td key={1000 + index}>
                                        <div className='data-table-input-cell'>
                                            <p className='data-table-text'>{renderRow(tableRow[tableCol])}
                                             </p>
                                        </div>
                                    </td>
                                )
                            })}

                        </tr>
                    )
                })}
            </tbody>
        </table>       
    )
}

export default DataTable